import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PhasesSection } from '../components/PhasesSection';
import { AgendaSection } from '../components/AgendaSection';
import { RouteMapSection } from '../components/RouteMapSection';
import { VenueMapSection } from '../components/VenueMapSection';
import { PetWallSection } from '../components/PetWallSection';
import { TicketsSection } from '../components/TicketsSection';
import { SponsorsSection } from '../components/SponsorsSection';
import { ActivitiesSection } from '../components/ActivitiesSection';
import { LocationSection } from '../components/LocationSection';
import { CauseSection } from '../components/CauseSection';
import { ContactSection } from '../components/ContactSection';
import { SponsorsBannerSection } from '../components/SponsorsBannerSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-2261" />
      <ActivitiesSection data-id="element-2262" />
      <AboutSection data-id="element-2263" />
      <TicketsSection data-id="element-2264" />
      <CauseSection data-id="element-2265" />
      <SponsorsBannerSection data-id="element-2266" />
      <SponsorsSection data-id="element-2267" />
      <AgendaSection data-id="element-2268" />
      <RouteMapSection data-id="element-2269" />
      <VenueMapSection data-id="element-2270" />
      <PetWallSection data-id="element-2271" />
      <LocationSection data-id="element-2272" />
      <PhasesSection data-id="element-2273" />
      <ContactSection data-id="element-2274" />
    </>;
}